import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@arcadeai/design-system/components/ui/atoms/select";
import { cn } from "@arcadeai/design-system/lib/utils";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { useDataTable } from "./data-table";

// Constants for pagination
const PAGE_SIZE_FIVE = 5;
const PAGE_SIZE_TEN = 10;
const PAGE_SIZE_TWENTY = 20;
const PAGE_SIZE_THIRTY = 30;
const PAGE_SIZE_FORTY = 40;
const PAGE_SIZE_FIFTY = 50;
const PAGE_SIZE_OPTIONS = [
  PAGE_SIZE_FIVE,
  PAGE_SIZE_TEN,
  PAGE_SIZE_TWENTY,
  PAGE_SIZE_THIRTY,
  PAGE_SIZE_FORTY,
  PAGE_SIZE_FIFTY,
];
const PAGE_SIZE_SELECT_WIDTH = 70;

export function DataTablePagination() {
  const table = useDataTable();
  const selectedRows = table.getFilteredSelectedRowModel().rows;
  return (
    <div className="flex items-center justify-between gap-4 px-2">
      {selectedRows.length > 0 && (
        <div className="text-muted-foreground text-sm">
          {selectedRows.length} of {table.getFilteredRowModel().rows.length}{" "}
          row(s) selected.
        </div>
      )}
      <div
        className={cn(
          "flex flex-1 items-center space-x-2",
          selectedRows.length > 0 && "justify-center"
        )}
      >
        <div className="flex items-center space-x-2">
          <p className="font-medium text-sm">Rows per page</p>
          <Select
            onValueChange={(value) => {
              table.setPageSize(Number(value));
            }}
            value={`${table.getState().pagination.pageSize}`}
          >
            <SelectTrigger className={`h-8 w-[${PAGE_SIZE_SELECT_WIDTH}px]`}>
              <SelectValue placeholder={table.getState().pagination.pageSize} />
            </SelectTrigger>
            <SelectContent side="top">
              {PAGE_SIZE_OPTIONS.map((pageSize) => (
                <SelectItem key={pageSize} value={`${pageSize}`}>
                  {pageSize}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="flex items-center space-x-6 lg:space-x-8">
        <div className="flex w-[100px] items-center justify-center font-medium text-sm">
          {`Page ${table.getPageCount() === 0 ? "0" : table.getState().pagination.pageIndex + 1} of ${table.getPageCount()}`}
        </div>
        <div className="flex items-center space-x-2">
          <Button
            className="hidden h-8 w-8 p-0 lg:flex"
            disabled={!table.getCanPreviousPage()}
            onClick={() => table.setPageIndex(0)}
            variant="outline"
          >
            <span className="sr-only">Go to first page</span>
            <ChevronsLeft />
          </Button>
          <Button
            className="h-8 w-8 p-0"
            disabled={!table.getCanPreviousPage()}
            onClick={() => table.previousPage()}
            variant="outline"
          >
            <span className="sr-only">Go to previous page</span>
            <ChevronLeft />
          </Button>
          <Button
            className="h-8 w-8 p-0"
            disabled={!table.getCanNextPage()}
            onClick={() => table.nextPage()}
            variant="outline"
          >
            <span className="sr-only">Go to next page</span>
            <ChevronRight />
          </Button>
          <Button
            className="hidden h-8 w-8 p-0 lg:flex"
            disabled={!table.getCanNextPage()}
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            variant="outline"
          >
            <span className="sr-only">Go to last page</span>
            <ChevronsRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
